import React from 'react'
import { Link } from 'gatsby'
import { FiChevronRight } from 'react-icons/fi'
import AlignCenter from './styles'

/**
 * Renders a Breadcrumb.
 *
 * @component
 *
 * return (
 *   <Breadcrumb crumbs={obj}/>
 * );
 */
export const Breadcrumb = ({ crumbs }) => {
  return (
    <AlignCenter>
      <div>
        {crumbs.map(item => (
          <span key={item.id}>
            {item.link === '#' || item.link === '/' ? (
              <>
                {item.link === '#' ? (
                  <span>{item.title}</span>
                ) : (
                  <a href={`${item.link}`}>{item.title}</a>
                )}
              </>
            ) : (
              <>
                <Link to={`/${item.link}`}>{item.title}</Link>
              </>
            )}
            {item.icon && <FiChevronRight size="1.5em" />}
          </span>
        ))}
      </div>
    </AlignCenter>
  )
}
export default Breadcrumb
